import { useAuthUser } from "react-auth-kit";
import { useAccessRight } from "./useAccessRight";
import {
  ACTION_ACCESS_HIDDEN,
  ACTION_ACCESS_ACCESSIBLE,
} from "../data/actionRegistry";

/**
 * Per-button action permissions from userRole.actionLinks.
 * Combines with page-level accessRight from useAccessRight.
 */
export const useActionRight = () => {
  const auth = useAuthUser();
  const { userRole } = auth() ?? {};
  const [, pageAccessRight] = useAccessRight();

  const getActionRight = (entity, action) => {
    const entry = userRole?.actionLinks?.find(
      (a) => a.entity === entity && a.action === action
    );
    return entry?.accessRight ?? ACTION_ACCESS_HIDDEN;
  };

  const isActionVisible = (entity, action) => {
    if (pageAccessRight === 0) return false;
    return getActionRight(entity, action) !== ACTION_ACCESS_HIDDEN;
  };

  /**
   * @param {string} entity
   * @param {string} action
   * @param {{ requireFullAccess?: boolean }} options
   */
  const isActionEnabled = (entity, action, options = {}) => {
    const { requireFullAccess = true } = options;

    if (!isActionVisible(entity, action)) return false;
    if (pageAccessRight === 1) return false;
    if (getActionRight(entity, action) !== ACTION_ACCESS_ACCESSIBLE) {
      return false;
    }
    if (requireFullAccess && pageAccessRight !== 15) return false;
    return true;
  };

  /** @deprecated use isActionEnabled */
  const canAccessAction = isActionEnabled;

  return {
    getActionRight,
    isActionVisible,
    isActionEnabled,
    canAccessAction,
    pageAccessRight,
  };
};
